var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 23,
    viewBox: "0 0 35 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.3667 21.436L0.757324 6.82666C-0.252441 5.81689 -0.252441 4.18408 0.757324 3.18506L3.18506 0.757324C4.19482 -0.252441 5.82764 -0.252441 6.82666 0.757324L17.1821 11.1128L27.5376 0.757324C28.5474 -0.252441 30.1802 -0.252441 31.1792 0.757324L33.6284 3.17432C34.6382 4.18408 34.6382 5.81689 33.6284 6.81592L19.019 21.4253C18.0093 22.4458 16.3765 22.4458 15.3667 21.436Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4cc44864a5e415d4f0cb163b1b013be8.svg";
export { ForwardRef as ReactComponent };